module.exports = __webpack_public_path__ + "static/publicArt-25_1-65511cf9042254e15980e8df93c26f09.jpg";